import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BenficiaryCardComponent } from './components/benficiary-card/benficiary-card.component';
import { KettoAssuredModule } from '../ketto-assured/ketto-assured.module';
import { ViewSupportersModule } from '../view-supporters/view-supporters.module';
import { SupportCardModule } from '../support-card/support-card.module';
import { SharedModule } from '../../shared/shared.module';
import { KettoAssuredV2Module } from '../ketto-assured-v2/ketto-assured-v2.module';
import { OrderRecoCardModule } from '../order-reco-card/order-reco-card.module';
import { MatButtonModule } from '@angular/material/button';
import { ComponentLoader } from 'src/app/core/component-loader/component-loader.component';
import { SupportersComponent } from '../supporters/supporters.component';

@NgModule({
  imports: [
    CommonModule,
    KettoAssuredModule,
    ViewSupportersModule,
    SupportCardModule,
    SharedModule,
    KettoAssuredV2Module,
    OrderRecoCardModule,
    MatButtonModule,
    ComponentLoader,
    SupportersComponent
  ],
  declarations: [BenficiaryCardComponent],
  exports: [BenficiaryCardComponent],
})
export class BenficiaryCardModule { }
